// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kSBA7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _init = require("@mediajel/tracker-core/snowplow/v1/init");
const createSnowplowV1Tracker = async (input)=>{
    // Dynamically load only the handler the event needs (package-specifier form — see snowplow/tracker.ts).
    const loadEcommerce = async ()=>(await require("d7836cec94d2725f")).default(input);
    const loadImpressions = async ()=>(await require("ca72b3df7a21f665")).default();
    return {
        context: input,
        initialize: (0, _init.initialize),
        // Load ecommerce handler only if the event is a transaction or if no event is specified
        ecommerce: input.event === "transaction" || !input.event ? await loadEcommerce() : undefined,
        impressions: input.event === "impression" ? await loadImpressions() : undefined,
        trackSignup: (input)=>{
            const { uuid, firstName, lastName, gender, emailAddress, hashedEmailAddress, address, city, state, phoneNumber, advertiser } = input;
            window.tracker("trackSelfDescribingEvent", {
                schema: "iglu:com.mediajel.events/sign_up/jsonschema/1-0-2",
                data: {
                    uuid,
                    firstName,
                    lastName,
                    gender,
                    emailAddress,
                    hashedEmailAddress,
                    address,
                    city,
                    state,
                    phoneNumber,
                    advertiser
                }
            });
        },
        record: (input)=>{
            window.tracker("trackSelfDescribingEvent", {
                schema: "iglu:com.mediajel.events/record/jsonschema/1-0-2",
                data: input
            });
        }
    };
};
exports.default = createSnowplowV1Tracker;

},{"@mediajel/tracker-core/snowplow/v1/init":"f49Lu","d7836cec94d2725f":"kMMmd","ca72b3df7a21f665":"gxJVA","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"f49Lu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialize", ()=>initialize);
var _formPiiFilter = require("@mediajel/tracker-core/snowplow/form-pii-filter");
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const initialize = ({ appId, collector, event, sdkUrl })=>{
    (0, _loggerDefault.default).debug(`SDK URL: ${sdkUrl}`);
    // Loading tracker with the snowplow tag by fetching our sp.js file
    // Creates a global function called "tracker" which we use to access the Snowplow Tracker
    (function(e, o, n, t, a, c, i) {
        if (!e[a]) {
            e.GlobalSnowplowNamespace = e.GlobalSnowplowNamespace || [];
            e.GlobalSnowplowNamespace.push(a);
            e[a] = function() {
                (e[a].q = e[a].q || []).push(arguments);
            };
            e[a].q = e[a].q || [];
            c = o.createElement(n);
            i = o.getElementsByTagName(n)[0];
            c.async = 1;
            c.src = t;
            i.parentNode.insertBefore(c, i);
        }
    })(window, document, "script", "//dm2q9qfzyjfox.cloudfront.net/sp.js", "tracker");
    // Creates the tracker with the appId and sends events to collector url
    window.tracker("newTracker", appId, `${collector}`, {
        appId: appId,
        postPath: "/analytics/track",
        discoverRootDomain: true,
        stateStorageStrategy: "cookieAndLocalStorage",
        cookieSameSite: "Lax",
        // Privacy-compliant posture: first-party Secure cookies, and honor Do Not Track at the SDK
        // level too. The tag's edge gate (isUsPrivacyOptOut) already hard-exits on GPC/DNT before the
        // tracker loads; respectDoNotTrack is a second, SDK-level guard so DNT is still honored on any
        // path that reaches the Snowplow tracker.
        cookieSecure: true,
        respectDoNotTrack: true,
        eventMethod: "post"
    });
    window.tracker("enableActivityTracking", 30, 10);
    window.tracker("trackPageView");
    // Exclude PII/sensitive fields (email, password, phone, payment…) from form capture.
    window.tracker("enableFormTracking", {
        fields: {
            filter: (0, _formPiiFilter.isNonSensitiveFormField)
        }
    });
    /**
   * !IMPORTANT: We are disabling this as to not override Link click config for the impression pixel.
   * Enabling this for impressions will cause click tracking to break
   */ if (event !== "impression") window.tracker("enableLinkClickTracking");
};

},{"@mediajel/tracker-core/snowplow/form-pii-filter":"hawoj","@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"hawoj":[function(require,module,exports) {
/**
 * Field filter for Snowplow form tracking. Returns `true` to TRACK a field, `false` to skip it.
 *
 * Excludes likely-PII / sensitive form fields (email, password, phone, payment card, SSN, auth
 * secrets, date-of-birth) — matched by input `type`, `name`, or `id` — so their values are never
 * captured by form tracking. Privacy/compliance guard; see the README "Privacy & compliance".
 *
 * Wired into both tracker versions' `enableFormTracking`:
 *   - classic `sp.js` (v1): `{ fields: { filter } }`
 *   - `cnna.js` v3 (v2):    `{ options: { fields: { filter } } }`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNonSensitiveFormField", ()=>isNonSensitiveFormField);
const isNonSensitiveFormField = (elt)=>{
    if (!elt) return true;
    const haystack = `${elt.name || ""} ${elt.id || ""} ${elt.type || ""}`.toLowerCase();
    // pass(word) · email · phone/tel · ssn/social · payment card (cc-/cvv/cvc) · auth secrets · dob/birth
    return !/pass|email|e-mail|phone|tel|ssn|social|card|cc-|cvv|cvc|secret|token|dob|birth/.test(haystack);
};
exports.default = isNonSensitiveFormField;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"kMMmd":[function(require,module,exports) {
module.exports = require("18b90861f376d1d5")(require("e7f606a3b5374de4").resolve("jlq9X")).then(()=>module.bundle.root("8c888"));

},{"18b90861f376d1d5":"auCaP","e7f606a3b5374de4":"cH4oS"}],"gxJVA":[function(require,module,exports) {
module.exports = require("91665576acf015f6")(require("f789ab8917db0442").resolve("b9P7V")).then(()=>module.bundle.root("3Jabv"));

},{"91665576acf015f6":"auCaP","f789ab8917db0442":"cH4oS"}]},[], null, "parcelRequire07df")

//# sourceMappingURL=tracker.cc8328b3.js.map
